<template>
  <v-tooltip right>
    <template v-slot:activator="{ on, attrs }">
      <v-speed-dial absolute bottom left fab direction="bottom">
        <template v-slot:activator>
          <v-btn fab v-bind="attrs" v-on="on" id="event-share-speed-dial-button">
            <v-icon>{{ icon.mdiShareVariant }}</v-icon>
          </v-btn>
        </template>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#4267B2" dark small fab v-bind="attrs" v-on="on" @click="facebookShare()" id="event-share-facebook-button">
              <v-icon>{{ icon.mdiFacebook }}</v-icon>
            </v-btn>
          </template>
          <span>Facebook</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#1DA1F2" dark  small fab v-bind="attrs" v-on="on" @click="twitterShare()" id="event-share-twitter-button">
              <v-icon>{{ icon.mdiTwitter }}</v-icon>
            </v-btn>
          </template>
          <span>Twitter</span>
        </v-tooltip>
      </v-speed-dial>
    </template>
    <span>{{$t('PROGRAM.share')}}</span>
  </v-tooltip>
</template>

<script>
import { mdiShareVariant, mdiFacebook, mdiTwitter, mdiLink } from "@mdi/js";
export default {
  props: ["event"],
  data() {
    return {
      icon: {
        mdiShareVariant,
        mdiFacebook,
        mdiTwitter,
        mdiLink,
      },
    };
  },
  methods: {
    twitterShare() {
      let message = `Check out this event: "${this.event.content[`${this.$i18n.locale}`].title}" on the`;
      let url = `${window.location.origin}${this.$route.path}`;
      let hashtags = `jornadasHCI`;
      let request = `http://twitter.com/share?text=${message}&url=${url}&hashtags=${hashtags}`;
      window.open(request);
    },
    facebookShare() {
      let request = `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fhci2021.web.app%2Fprogram&amp;src=sdkpreparse`;
      window.open(request);
    },
  },
};
</script>